type FilterValue = string | string[] | number | boolean;

// copied from https://stackoverflow.com/a/63331703/10997094
export default function compareArrays(
  arr1: FilterValue[],
  arr2: FilterValue[]
) {
  function vKey(_: number, v: FilterValue) {
    return `${typeof v}-${v}`;
  }

  if (arr1.length !== arr2.length) return false;

  const d1 = {};
  const d2 = {};
  for (let i = arr1.length - 1; i >= 0; i -= 1) {
    d1[vKey(i, arr1[i])] = true;
    d2[vKey(i, arr2[i])] = true;
  }

  for (let i = arr1.length - 1; i >= 0; i -= 1) {
    const v = vKey(i, arr1[i]);
    if (d1[v] !== d2[v]) return false;
  }

  for (let i = arr2.length - 1; i >= 0; i -= 1) {
    const v = vKey(i, arr2[i]);
    if (d1[v] !== d2[v]) return false;
  }

  return true;
}
